"use client";

import { motion } from "motion/react";
import type { ComponentProps, ReactNode } from "react";
import { TabErrorBoundary } from "./tab-error-boundary";

/**
 * One route's animated layer (the `motion.div` that slides in and out) with its
 * content inside a `TabErrorBoundary`. Takes exactly the props of `motion.div`,
 * so it drops in where that was.
 */
export function RouteLayer({
  children,
  ...props
}: Omit<ComponentProps<typeof motion.div>, "children"> & { children?: ReactNode }) {
  return (
    <motion.div {...props}>
      <TabErrorBoundary>{children}</TabErrorBoundary>
    </motion.div>
  );
}
